import apiClient from '../utils/apiClient';

/**
 * Shift Leaderboard API — bảng xếp hạng điểm đóng góp đăng ký ca theo tuần của 1 chi nhánh.
 * Cùng nguồn dữ liệu với bảng đang chạy trên app nhân viên (GET /shift-leaderboard).
 */
export const shiftLeaderboardAPI = {
  /**
   * Lấy bảng xếp hạng đóng góp ca.
   * @param {string} branchId - ID chi nhánh (bắt buộc)
   * @param {string} [week] - Ngày bất kỳ (YYYY-MM-DD) thuộc tuần muốn xem.
   *                          Bỏ trống = tuần làm việc kế tiếp (mặc định của máy chủ).
   * @returns {Promise<Object>} { week_start, week_end, reward_tiers, entries[], is_locked, ... }
   */
  getLeaderboard: async (branchId, week = '') => {
    return await apiClient.get({
      url: '/shift-leaderboard',
      params: week ? { branch_id: branchId, week } : { branch_id: branchId },
    });
  },
};

export default shiftLeaderboardAPI;
